// ------------------------------------ User ----------------------------------------------

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET'

export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST'
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS'
export const GET_USER_PROFILE_FAIL = 'GET_USER_PROFILE_FAIL'
export const GET_USER_PROFILE_RESET = 'GET_USER_PROFILE_RESET'

export const GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST'
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS'
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL'
export const GET_ALL_USERS_RESET = 'GET_ALL_USERS_RESET'

export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST'
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS'
export const UPDATE_USER_PROFILE_FAIL = 'UPDATE_USER_PROFILE_FAIL'
export const UPDATE_USER_PROFILE_RESET = 'UPDATE_USER_PROFILE_RESET'

export const USER_AUTH_REQUEST = 'USER_AUTH_REQUEST'
export const USER_AUTH_SUCCESS = 'USER_AUTH_SUCCESS'
export const USER_AUTH_FAIL = 'USER_AUTH_FAIL'
export const USER_AUTH_LOGOUT = 'USER_AUTH_LOGOUT'

export const USER_VERIFY_EMAIL_REQUEST = 'USER_VERIFY_EMAIL_REQUEST'
export const USER_VERIFY_EMAIL_SUCCESS = 'USER_VERIFY_EMAIL_SUCCESS'
export const USER_VERIFY_EMAIL_FAIL = 'USER_VERIFY_EMAIL_FAIL'
export const USER_VERIFY_EMAIL_RESET = 'USER_VERIFY_EMAIL_RESET'

export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST'
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS'
export const GET_USER_DETAILS_FAIL = 'GET_USER_DETAILS_FAIL'
export const GET_USER_DETAILS_RESET = 'GET_USER_DETAILS_RESET'

// ------------------------------------ Admin ----------------------------------------------

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'

export const GET_ADMIN_PROFILE_REQUEST = 'GET_ADMIN_PROFILE_REQUEST'
export const GET_ADMIN_PROFILE_SUCCESS = 'GET_ADMIN_PROFILE_SUCCESS'
export const GET_ADMIN_PROFILE_FAIL = 'GET_ADMIN_PROFILE_FAIL'
export const GET_ADMIN_PROFILE_RESET = 'GET_ADMIN_PROFILE_RESET'

export const UPDATE_ADMIN_PROFILE_REQUEST = 'UPDATE_ADMIN_PROFILE_REQUEST'
export const UPDATE_ADMIN_PROFILE_SUCCESS = 'UPDATE_ADMIN_PROFILE_SUCCESS'
export const UPDATE_ADMIN_PROFILE_FAIL = 'UPDATE_ADMIN_PROFILE_FAIL'
export const UPDATE_ADMIN_PROFILE_RESET = 'UPDATE_ADMIN_PROFILE_RESET'

// ------------------------------------ Campaign ----------------------------------------------

export const CAMPAIGN_CREATE_REQUEST = 'CAMPAIGN_CREATE_REQUEST'
export const CAMPAIGN_CREATE_SUCCESS = 'CAMPAIGN_CREATE_SUCCESS'
export const CAMPAIGN_CREATE_FAIL = 'CAMPAIGN_CREATE_FAIL'
export const CAMPAIGN_CREATE_RESET = 'CAMPAIGN_CREATE_RESET'

export const GET_ALL_CAMPAIGNS_REQUEST = 'GET_ALL_CAMPAIGNS_REQUEST'
export const GET_ALL_CAMPAIGNS_SUCCESS = 'GET_ALL_CAMPAIGNS_SUCCESS'
export const GET_ALL_CAMPAIGNS_FAIL = 'GET_ALL_CAMPAIGNS_FAIL'
export const GET_ALL_CAMPAIGNS_RESET = 'GET_ALL_CAMPAIGNS_RESET'

export const GET_CURRENT_CAMPAIGN_REQUEST = 'GET_CURRENT_CAMPAIGN_REQUEST'
export const GET_CURRENT_CAMPAIGN_SUCCESS = 'GET_CURRENT_CAMPAIGN_SUCCESS'
export const GET_CURRENT_CAMPAIGN_FAIL = 'GET_CURRENT_CAMPAIGN_FAIL'
export const GET_CURRENT_CAMPAIGN_RESET = 'GET_CURRENT_CAMPAIGN_RESET'

export const GET_CAMPAIGN_DETAILS_REQUEST = 'GET_CAMPAIGN_DETAILS_REQUEST'
export const GET_CAMPAIGN_DETAILS_SUCCESS = 'GET_CAMPAIGN_DETAILS_SUCCESS'
export const GET_CAMPAIGN_DETAILS_FAIL = 'GET_CAMPAIGN_DETAILS_FAIL'
export const GET_CAMPAIGN_DETAILS_RESET = 'GET_CAMPAIGN_DETAILS_RESET'

export const UPDATE_CAMPAIGN_DETAILS_REQUEST = 'UPDATE_CAMPAIGN_DETAILS_REQUEST'
export const UPDATE_CAMPAIGN_DETAILS_SUCCESS = 'UPDATE_CAMPAIGN_DETAILS_SUCCESS'
export const UPDATE_CAMPAIGN_DETAILS_FAIL = 'UPDATE_CAMPAIGN_DETAILS_FAIL'
export const UPDATE_CAMPAIGN_DETAILS_RESET = 'UPDATE_CAMPAIGN_DETAILS_RESET'

export const UPDATE_CAMPAIGN_STATUS_REQUEST = 'UPDATE_CAMPAIGN_STATUS_REQUEST'
export const UPDATE_CAMPAIGN_STATUS_SUCCESS = 'UPDATE_CAMPAIGN_STATUS_SUCCESS'
export const UPDATE_CAMPAIGN_STATUS_FAIL = 'UPDATE_CAMPAIGN_STATUS_FAIL'
export const UPDATE_CAMPAIGN_STATUS_RESET = 'UPDATE_CAMPAIGN_STATUS_RESET'

// ------------------------------------ Submissions ----------------------------------------------

export const CREATE_SUBMISSION_REQUEST = 'CREATE_SUBMISSION_REQUEST'
export const CREATE_SUBMISSION_SUCCESS = 'CREATE_SUBMISSION_SUCCESS'
export const CREATE_SUBMISSION_FAIL = 'CREATE_SUBMISSION_FAIL'
export const CREATE_SUBMISSION_RESET = 'CREATE_SUBMISSION_RESET'

export const ADMIN_GET_ALL_SUBMISSIONS_REQUEST =
	'ADMIN_GET_ALL_SUBMISSIONS_REQUEST'
export const ADMIN_GET_ALL_SUBMISSIONS_SUCCESS =
	'ADMIN_GET_ALL_SUBMISSIONS_SUCCESS'
export const ADMIN_GET_ALL_SUBMISSIONS_FAIL = 'ADMIN_GET_ALL_SUBMISSIONS_FAIL'
export const ADMIN_GET_ALL_SUBMISSIONS_RESET = 'ADMIN_GET_ALL_SUBMISSIONS_RESET'

export const GET_SUBMISSION_DETAILS_REQUEST = 'GET_SUBMISSION_DETAILS_REQUEST'
export const GET_SUBMISSION_DETAILS_SUCCESS = 'GET_SUBMISSION_DETAILS_SUCCESS'
export const GET_SUBMISSION_DETAILS_FAIL = 'GET_SUBMISSION_DETAILS_FAIL'
export const GET_SUBMISSION_DETAILS_RESET = 'GET_SUBMISSION_DETAILS_RESET'

export const UPDATE_SUBMISSION_DETAILS_REQUEST =
	'UPDATE_SUBMISSION_DETAILS_REQUEST'
export const UPDATE_SUBMISSION_DETAILS_SUCCESS =
	'UPDATE_SUBMISSION_DETAILS_SUCCESS'
export const UPDATE_SUBMISSION_DETAILS_FAIL = 'UPDATE_SUBMISSION_DETAILS_FAIL'
export const UPDATE_SUBMISSION_DETAILS_RESET = 'UPDATE_SUBMISSION_DETAILS_RESET'

export const USER_GET_ALL_SUBMISSIONS_REQUEST =
	'USER_GET_ALL_SUBMISSIONS_REQUEST'
export const USER_GET_ALL_SUBMISSIONS_SUCCESS =
	'USER_GET_ALL_SUBMISSIONS_SUCCESS'
export const USER_GET_ALL_SUBMISSIONS_FAIL = 'USER_GET_ALL_SUBMISSIONS_FAIL'
export const USER_GET_ALL_SUBMISSIONS_RESET = 'USER_GET_ALL_SUBMISSIONS_RESET'

export const USER_GET_SUBMISSION_DETAILS_REQUEST =
	'USER_GET_SUBMISSION_DETAILS_REQUEST'
export const USER_GET_SUBMISSION_DETAILS_SUCCESS =
	'USER_GET_SUBMISSION_DETAILS_SUCCESS'
export const USER_GET_SUBMISSION_DETAILS_FAIL =
	'USER_GET_SUBMISSION_DETAILS_FAIL'
export const USER_GET_SUBMISSION_DETAILS_RESET =
	'USER_GET_SUBMISSION_DETAILS_RESET'
